import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import TableRow from "@mui/material/TableRow";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { deleteInvestmentType } from "../../actions/investmentType";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";

import secureLocalStorage from "react-secure-storage";
import { createInvestmentType } from "../../actions/investmentType";
import toast from "react-hot-toast";
import { message, Popconfirm } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  color: "black",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  {
    id: "investment_type",
    label: "Investment Type",
    minWidth: 100,
    align: "left",
  },
  {
    id: "code",
    label: "CODE",
    minWidth: 170,
    align: "left",
  },
];

export default function InvestmentType() {
  function createData(id, investment_type, code) {
    return { id, investment_type, code };
  }
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [investmentType, setInvestmentType] = React.useState({
    investment_type: "",
    code: "",
  });
  const investmentTypes = useSelector((state) => state.investmentTypes);
  const rows = investmentTypes.map((data) =>
    createData(data._id, data.investment_type, data.code)
  );

  // const assetCat = useSelector((state) => state.category);

  // category.intangible_category = checked;
  const dispatch = useDispatch();
  function sendData() {
    if (!investmentType.investment_type && !investmentType.code) {
      toast.error("Please fill in required fields");
      return;
    }
    dispatch(createInvestmentType(investmentType));
    setInvestmentType("");
    handleClose();
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  let allowManipulate = false;
  if (
    user.results.portfolio_manager === "Administrator" ||
    user.results.portfolio_manager === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }

  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px" }}>
                Add Investment Type
              </Typography>
              <form>
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Investment type'
                  value={investmentType.investment_type}
                  onChange={(e) =>
                    setInvestmentType({
                      ...investmentType,
                      investment_type: e.target.value,
                    })
                  }
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='code'
                  value={investmentType.code}
                  onChange={(e) =>
                    setInvestmentType({
                      ...investmentType,
                      code: e.target.value,
                    })
                  }
                  required
                />

                <div>
                  <Button
                    variant='contained'
                    onClick={sendData}
                    size='small'
                    style={{
                      textTransform: "none",
                      margin: "5px",
                    }}>
                    Submit
                  </Button>
                  <Button
                    variant='contained'
                    style={{
                      textTransform: "none",
                      backgroundColor: "#D32F2F",
                    }}
                    onClick={handleClose}
                    size='small'>
                    Cancel
                  </Button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Button
          disabled={!allowManipulate}
          size='small'
          style={{
            textTransform: "capitalize",
            margin: "5px",
          }}
          onClick={handleOpen}
          variant='contained'>
          Add Investment Type
        </Button>
        <em style={{ color: "red" }}>
          {allowManipulate
            ? ""
            : "you don't have the permission to add asset pool"}
        </em>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table
            size='small'
            stickyHeader
            aria-label='sticky table'
            // style={{ backgroundColor: "#E9F1F7" }}
            sx={{
              "& tr > *:last-child": {
                position: "sticky",
                right: 0,

                // bgcolor: "#cccc",
              },
            }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#f8f8f8",
                      color: "#000000",
                      fontWeight: "bold",
                    }}>
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  align='center'
                  style={{
                    backgroundColor: "#f8f8f8",
                    color: "#000000",
                    fontWeight: "bold",
                  }}>
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row) => {
                  return (
                    <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            fontSize: "14px",
                          }}>
                          <Popconfirm
                            onCancel={() => {
                              message.info("Nothing was deleted");
                            }}
                            title='Do you want to delete this investment type?'
                            okText='Yes'
                            onConfirm={() =>
                              dispatch(deleteInvestmentType(row.id))
                            }>
                            <Tooltip title='Delete'>
                              <IconButton>
                                <DeleteIcon
                                  style={{ fontSize: "18px", color: "red" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Popconfirm>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
